exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.kye-report-arrow {\n  font-size: 12px;\n}\n.layout-report-up {\n  color: #1BC467;\n}\n.layout-report-down {\n  color: #FF5555;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-report-form/card/common/arrow.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB;AACD;EACE,eAAe;CAChB;AACD;EACE,eAAe;CAChB","file":"arrow.vue","sourcesContent":["\n.kye-report-arrow {\n  font-size: 12px;\n}\n.layout-report-up {\n  color: #1BC467;\n}\n.layout-report-down {\n  color: #FF5555;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8975100c","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/public/components/kye-report-form/card/common/arrow.vue
// module id = wqje
// module chunks = 6